import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "pa-5 mt-5" },
    [
      _c(VCardTitle, [
        _c("span", { staticClass: "headline" }, [
          _vm._v("Conversion Analysis"),
        ]),
      ]),
      _c(
        VCardText,
        [
          _c(
            VBtnToggle,
            {
              staticClass: "mb-4",
              model: {
                value: _vm.analysisMode,
                callback: function ($$v) {
                  _vm.analysisMode = $$v
                },
                expression: "analysisMode",
              },
            },
            [
              _c(VBtn, { attrs: { value: "filtered" } }, [
                _vm._v("Filtered Data"),
              ]),
              _c(VBtn, { attrs: { value: "overall" } }, [
                _vm._v("Overall Data"),
              ]),
            ],
            1
          ),
          _c(
            VTabs,
            {
              attrs: { "background-color": "transparent" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(VTab, { key: "chain" }, [_vm._v("Process Chain Analysis")]),
              _c(VTab, { key: "group" }, [_vm._v("Product Group Analysis")]),
              _c(VTab, { key: "matrix" }, [_vm._v("Input–Output Matrix")]),
              _c(VTab, { key: "detailed" }, [
                _vm._v("Detailed Chain Analysis"),
              ]),
            ],
            1
          ),
          _c(VDivider, { staticClass: "mb-4" }),
          _vm.activeTab === 0
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-4",
                      staticStyle: { "font-style": "italic" },
                    },
                    [
                      _vm._v(
                        " This analysis displays each process chain from the aggregated data. For each chain, the conversion rate is calculated as (total output ÷ total input) × 100%. The process chain column shows the process start time and a clickable process code linking to the worksheet. "
                      ),
                    ]
                  ),
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.chainHeaders,
                      items: _vm.processChainAnalysis,
                      dense: "",
                      "items-per-page": 5,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.chainDisplay",
                          fn: function ({ item }) {
                            return _vm._l(item.chainDisplay, function (proc) {
                              return _c("div", { key: proc.id }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatDateTime")(proc.time)
                                    ) +
                                    " - "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: `${_vm.backofficeUrl}/factory/process/${proc.id}`,
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(proc.code) + " ")]
                                ),
                              ])
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      894037210
                    ),
                  }),
                ],
                1
              )
            : _vm.activeTab === 1
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-4",
                      staticStyle: { "font-style": "italic" },
                    },
                    [
                      _vm._v(
                        " The Product Group Analysis is separated into two tables: "
                      ),
                      _c("br"),
                      _c("br"),
                      _c("strong", [_vm._v("Input Groups Analysis:")]),
                      _c("ul", [
                        _c("li", [
                          _c("em", [_vm._v("Total Input")]),
                          _vm._v(": Sum of raw input for the group."),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Input %")]),
                          _vm._v(": Group’s share of overall input."),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Attributed Output")]),
                          _vm._v(
                            ": Output attributed to this input group (from the Input–Output Matrix)."
                          ),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Output %")]),
                          _vm._v(
                            ": Percentage of overall output represented by this attributed output."
                          ),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Efficiency")]),
                          _vm._v(": (Attributed Output ÷ Total Input) × 100%."),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Delta")]),
                          _vm._v(
                            ": (Output % – Input %), indicating over- or under-performance."
                          ),
                        ]),
                      ]),
                      _c("strong", [_vm._v("Output Groups Analysis:")]),
                      _c("ul", [
                        _c("li", [
                          _c("em", [_vm._v("Total Output")]),
                          _vm._v(": Sum of outputs for the group."),
                        ]),
                        _c("li", [
                          _c("em", [_vm._v("Output %")]),
                          _vm._v(": Group’s share of overall output."),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    VCard,
                    { staticClass: "mb-4", attrs: { outlined: "" } },
                    [
                      _c(VCardTitle, [_vm._v("Input Groups Analysis")]),
                      _c(
                        VCardText,
                        [
                          _c(VDataTable, {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.inputGroupHeaders,
                              items: _vm.inputGroupAnalysis,
                              dense: "",
                              "hide-default-footer": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCard,
                    { attrs: { outlined: "" } },
                    [
                      _c(VCardTitle, [_vm._v("Output Groups Analysis")]),
                      _c(
                        VCardText,
                        [
                          _c(VDataTable, {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.outputGroupHeaders,
                              items: _vm.outputGroupAnalysis,
                              dense: "",
                              "hide-default-footer": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.activeTab === 2
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-4",
                      staticStyle: { "font-style": "italic" },
                    },
                    [
                      _vm._v(
                        ' The Input–Output Matrix shows how outputs are distributed across input groups for each process chain. Each cell represents the percentage contribution of an input group to a specific output group. The final column "Overall %" compares each input group’s total contribution to the combined output across all chains. '
                      ),
                    ]
                  ),
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.matrixHeaders,
                      items: _vm.inputOutputMatrixRows,
                      dense: "",
                      "hide-default-footer": "",
                    },
                  }),
                ],
                1
              )
            : _vm.activeTab === 3
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-4",
                      staticStyle: { "font-style": "italic" },
                    },
                    [
                      _vm._v(
                        " This detailed view provides a breakdown for each process chain. It shows the process chain display (process start time and clickable code) along with a detailed breakdown of input and output percentages by product group. "
                      ),
                    ]
                  ),
                  _c(VDataTable, {
                    key: _vm.detailedTableKey,
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.detailedChainHeaders,
                      items: _vm.detailedChainAnalysis,
                      dense: "",
                      "items-per-page": 5,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.chainDisplay",
                        fn: function ({ item }) {
                          return _vm._l(item.chainDisplay, function (proc) {
                            return _c("div", { key: proc.id }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("formatDateTime")(proc.time)) +
                                  " - "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: `${_vm.backofficeUrl}/factory/process/${proc.id}`,
                                  },
                                },
                                [_vm._v(" " + _vm._s(proc.code) + " ")]
                              ),
                            ])
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }